// Aggressive suppression of CacheStorage errors from browser extensions
(function () {
  if (typeof window === 'undefined') return;

  const errorPatterns = [
    /CacheStorage/i,
    /cache.*internal error/i,
    /Failed to execute 'open' on 'CacheStorage'/i,
    /Unexpected internal error/i,
    /MetaMask/i,
    /Failed to connect to MetaMask/i
  ];

  const shouldSuppress = (message: any): boolean => {
    const str = String(message || '');
    return errorPatterns.some(pattern => pattern.test(str));
  };

  // Override console methods
  const originalConsole = {
    error: console.error,
    warn: console.warn,
    log: console.log
  };

  console.error = function (...args: any[]) {
    if (args.some(arg => shouldSuppress(arg))) return;
    originalConsole.error.apply(console, args);
  };

  console.warn = function (...args: any[]) {
    if (args.some(arg => shouldSuppress(arg))) return;
    originalConsole.warn.apply(console, args);
  };

  console.log = function (...args: any[]) {
    if (args.some(arg => shouldSuppress(arg))) return;
    originalConsole.log.apply(console, args);
  };

  // Capture error events
  window.addEventListener('error', (event) => {
    const msg = event.message || event.error?.message || '';
    if (shouldSuppress(msg)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);

  // Capture unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    const msg = event.reason?.message || event.reason || '';
    if (shouldSuppress(msg)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    }
  }, true);

  // Override window.onerror
  const originalOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (shouldSuppress(message) || shouldSuppress(error?.message)) {
      return true; // Prevent default error handling
    }
    if (originalOnError) {
      return originalOnError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  // Override window.onunhandledrejection
  const originalOnUnhandledRejection = window.onunhandledrejection;
  window.onunhandledrejection = function (event: PromiseRejectionEvent) {
    const msg = event.reason?.message || event.reason || '';
    if (shouldSuppress(msg)) {
      event.preventDefault();
      return true;
    }
    if (originalOnUnhandledRejection) {
      return originalOnUnhandledRejection.call(window, event);
    }
    return false;
  };

})();

export { };
